const couponItemEndpoints = {
  getCouponItems: "/coupons/getCouponItems",
  getCouponById: "/coupons/:id",
};

export default couponItemEndpoints;
